import {Component, OnInit} from '@angular/core';
import {ModuleRiskService} from "../../core/risk-module/module-risk.service";
import {MessageService} from "primeng/components/common/messageservice";

@Component({
  selector: 'app-risks-module',
  templateUrl: './risks-module.component.html',
  styleUrls: ['./risks-module.component.scss']
})
export class RisksModuleComponent implements OnInit {
  limitPurchase = '';
  isLoading = false;

  constructor(private moduleRiskService: ModuleRiskService,
              private messageService: MessageService) {
  }

  ngOnInit() {
    this.getLimitPurchaseForUserWhiteList();
  }


  getLimitPurchaseForUserWhiteList() {
    this.moduleRiskService.getLimitPurchaseUserWhiteList().subscribe(amount => {
      console.log('Amount response: ', amount);
      this.limitPurchase = amount;
    });
  }

  updateValues() {
    this.isLoading = true;
    const newAmountRequest = {
      "newAmount": this.limitPurchase
    };
    this.moduleRiskService.updateLimitPurchaseUserWhiteList(newAmountRequest).subscribe(res => {
      this.isLoading = false;
      console.log('Actualizado');
      this.messageService.add({
        severity: 'success',
        summary: '',
        detail: 'Se actualizó el monto máximo de compra.'
      });
    }, error => {
      this.isLoading = false;
      this.messageService.add({
        severity: 'error',
        summary: '',
        detail: 'Ocurrió un error al actualizar monto'
      });
      console.log(error);
    });

  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/risks-module/risks-module.component.ts